import styled from "styled-components";

export default styled.div`
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
`;
